import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const LicensePlateAndVinStepAsync = lazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "license-plate-and-vin-step" */ 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/license-plate-and-vin-step/license-plate-and-vin-step'
    ),
  componentName: 'LicensePlateAndVinStepContextProvider',
});
